import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getItemsWithoutPlanId } from '../../services/claim-unclaim-products-service'

export const fetchUnclaimedProductsCount = createAsyncThunk(
  'claimOrReleaseProducts/fetchUnclaimedProductsCount',
  async (eventId: string) => {
    const res = await getItemsWithoutPlanId({
      eventId: eventId,
      page: 1,
      perPage: 1,
      requestBody: {},
    })
    const response = {}
    response[eventId] = res.data.count
    return response
  },
)

export const fetchUnclaimedProducts = createAsyncThunk(
  'claimOrReleaseProducts/fetchUnclaimedProducts',
  async (data: { eventId; page; perPage }) => {
    const { eventId, page, perPage } = data
    const res = await getItemsWithoutPlanId({
      eventId: eventId,
      page: page,
      perPage: perPage,
      requestBody: {},
    })
    const response = {}
    response[eventId] = res.data
    return response
  },
)

const initialState = {
  unclaimedProductsCount: {},
  unclaimedProducts: {},
}

const claimOrReleaseProductsSlice = createSlice({
  name: 'claimOrReleaseProducts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchUnclaimedProductsCount.fulfilled, (state, action) => {
        state.unclaimedProductsCount = {
          ...state.unclaimedProductsCount,
          ...action.payload,
        }
      })
      .addCase(fetchUnclaimedProducts.fulfilled, (state, action) => {
        state.unclaimedProducts = {
          ...state.unclaimedProducts,
          ...action.payload,
        }
      })
  },
})

export default claimOrReleaseProductsSlice.reducer
